import { Component, computed, input } from "@angular/core";

/** Descriptive helper text for each issue severity, keyed by the severity value. */
const SEVERITY_INFO: Record<string, string> = {
  minor: "A smaller issue typically resolved by a single trade. e.g., Paint touch-ups, scratched sink, door replacement, chipped countertop.",
  major: "A significant issue requiring rework and repair involving multiple trade partners. e.g., Uneven outlets in backsplash, damaged appliance, misaligned flooring, bowed wall, improperly installed tile.",
  missing: "An essential item that was never installed, such as an appliance, fireplace, or light fixture. Excludes small components like screws or trim caps."
};

/**
 * Info line describing the selected issue severity (Minor / Major / Missing).
 *
 * Renders a leading info icon and the matching description. Shows nothing until a known severity
 * (`minor` | `major` | `missing`) is provided, so it can be dropped in beneath a severity selector.
 * Pass `text` instead to reuse the same info-line styling for an arbitrary note.
 */
@Component({
  selector: "app-severity-info",
  standalone: true,
  templateUrl: "./severity-info.component.html",
  styleUrl: "./severity-info.component.scss"
})
export class SeverityInfoComponent {
  /** Selected severity value: `minor` | `major` | `missing`. */
  severity = input<string>("");
  /** Explicit note text; takes precedence over the severity lookup. */
  text = input<string>("");
  testId = input<string>("app-severity-info");

  /** Description for the current severity, or empty when none/unknown is selected. */
  protected readonly message = computed(() => this.text() || SEVERITY_INFO[this.severity()] || "");
}
